// eslint-disable-next-line import/prefer-default-export
export const SCHEMA = {
  id: null,
  type: null,
  filterSet: null,
  filter: null,
  redirectType: null,
  url: null,
  path: null,
  content_type: null,
  vocabulary: null,
  vocabularyId: null,
  meta: null,
}
